import { render } from "./ImportNetworkACL.vue?vue&type=template&id=4b0671ba&scoped=true"
import script from "./ImportNetworkACL.vue?vue&type=script&lang=js"
export * from "./ImportNetworkACL.vue?vue&type=script&lang=js"

import "./ImportNetworkACL.vue?vue&type=style&index=0&id=4b0671ba&scoped=true&lang=less"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.22.1.1/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b0671ba"]])

export default __exports__